import { Check, X, Clock } from "lucide-react";
import { formatWaktuID } from "@/lib/api";

const ICON = {
  Disetujui: { icon: Check, cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  Ditolak: { icon: X, cls: "bg-rose-100 text-rose-700 border-rose-200" },
  Menunggu: { icon: Clock, cls: "bg-amber-100 text-amber-700 border-amber-200" },
};

export function ApprovalChain({ chain = [], currentLevel = 0, status }) {
  if (!chain.length) {
    return (
      <div className="text-xs text-slate-500 italic" data-testid="chain-auto">
        Disetujui otomatis — tidak ada atasan yang ditetapkan.
      </div>
    );
  }
  return (
    <ol className="space-y-2" data-testid="approval-chain">
      {chain.map((c, i) => {
        const meta = ICON[c.status] || ICON.Menunggu;
        const Icon = meta.icon;
        const isCurrent = status === "Menunggu" && i === currentLevel;
        return (
          <li key={c.level} className="flex items-start gap-2.5" data-testid={`chain-level-${c.level}`}>
            <span
              className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border ${meta.cls}`}
            >
              <Icon size={12} />
            </span>
            <div className="min-w-0">
              <div className="text-xs font-semibold text-slate-800 leading-tight">
                Level {c.level} — {c.approver_nama}
                <span className="ml-1.5 text-[10px] font-bold uppercase tracking-wider text-slate-400">
                  {c.approver_role?.replace("_", " ")}
                </span>
                {isCurrent ? (
                  <span className="ml-1.5 text-[10px] font-bold uppercase tracking-wider text-amber-600">
                    • giliran saat ini
                  </span>
                ) : null}
              </div>
              <div className="text-[11px] text-slate-500 leading-tight mt-0.5">
                {c.status}
                {c.acted_at ? ` • ${formatWaktuID(c.acted_at)}` : ""}
                {c.acted_by_nama && c.acted_by_id !== c.approver_id
                  ? ` • oleh ${c.acted_by_nama} (admin)`
                  : ""}
              </div>
              {c.alasan_penolakan ? (
                <div className="text-[11px] text-rose-700 mt-0.5">
                  Alasan: {c.alasan_penolakan}
                </div>
              ) : null}
            </div>
          </li>
        );
      })}
    </ol>
  );
}

export default ApprovalChain;
